<div class="changes-container">
  <div class="changes-card">
    <span class="changes-title" i18n>Previous</span>
    <div class="d-flex flex-column gap-3" *ngIf="beneficiaryChanges?.old?.length">
      <app-beneficiary-submission-share-change *ngFor="let change of beneficiaryChanges?.old" [change]="change" />
    </div>
    <span *ngIf="!beneficiaryChanges?.old?.length" class="not-applicable" i18n>Not applicable</span>
  </div>
  <div class="changes-card">
    <span class="changes-title" i18n>New</span>
    <div class="d-flex flex-column gap-3" *ngIf="hasChanges">
      <app-beneficiary-submission-share-change *ngFor="let change of beneficiaryChanges?.new" [change]="change" />
    </div>
    <span *ngIf="!hasChanges" class="not-applicable">{{ noChangesText }}</span>
  </div>
</div>
